import script from "./Status.vue?vue&type=script&setup=true&lang=ts"
export * from "./Status.vue?vue&type=script&setup=true&lang=ts"

import "./Status.vue?vue&type=style&index=0&id=a35aaeb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a35aaeb4"]])

export default __exports__